/* Copyright (c) Trimble Inc. All rights reserved. */

const PHONE_AREA_CODE_LENGTH = 3;
const PHONE_PREFIX_LENGTH = 6;
const PHONE_MAX_DIGITS = 10;

export const formatPhoneNumber = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
  if (digits.length <= PHONE_AREA_CODE_LENGTH) return digits;
  if (digits.length <= PHONE_PREFIX_LENGTH)
    return `${digits.slice(0, PHONE_AREA_CODE_LENGTH)}-${digits.slice(PHONE_AREA_CODE_LENGTH)}`;
  return `${digits.slice(0, PHONE_AREA_CODE_LENGTH)}-${digits.slice(
    PHONE_AREA_CODE_LENGTH,
    PHONE_PREFIX_LENGTH,
  )}-${digits.slice(PHONE_PREFIX_LENGTH)}`;
};
